// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"846":"technical","981":"rules"}[chunkId] + "." + {"846":"76233ddb","981":"0669ba2a"}[chunkId] + ".js";
};